<template>
  <v-navigation-drawer
    expand-on-hover
    rail
    @update:rail="updateRail"
    :rail-width="60"
    width="260"
    permanent
    location="right"
    elevation="0"
  >
    <!-- Header label -->
    <div class="nav-brand">
      <v-icon color="warning" size="22">mdi-shield-crown-outline</v-icon>
      <div :class="['nav-brand-text', { 'nav-brand-text--hidden': !isDeploy }]">
        <div class="nav-brand-title" style="color: rgb(var(--v-theme-warning));">Administration</div>
        <div class="nav-brand-version">Panneau admin</div>
      </div>
    </div>

    <!-- Nav scroll area -->
    <div style="height: calc(100% - 64px); overflow-y: auto; overflow-x: hidden;" class="py-1">
      <template v-for="(category, catIndex) in navContent" :key="catIndex">
        <div :class="['nav-category-label', { 'nav-category-label--hidden': !isDeploy }]">{{ category.label }}</div>
        <router-link
          v-for="item in category.items"
          :key="item.path"
          :to="item.path"
          style="text-decoration: none;"
        >
          <div :class="['nav-item-container', $route.path === item.path ? 'nav-item-container--active' : '']" :style="$route.path === item.path ? { '--nav-item-color': getNavColorVar(item.color) } : {}">
            <v-list-item
              :active="$route.path === item.path"
              :color="item.color"
              density="compact"
            >
              <template v-slot:prepend>
                <v-icon :color="$route.path === item.path ? item.color : 'grey-darken-1'" size="20">{{ item.icon }}</v-icon>
              </template>
              <v-list-item-title>
                <span :class="['nav-item-label', $route.path !== item.path ? 'text-medium-emphasis' : 'text-' + item.color]">
                  {{ item.title }}
                </span>
              </v-list-item-title>
            </v-list-item>
          </div>
        </router-link>
      </template>
    </div>
  </v-navigation-drawer>
</template>

<script>
import navItems from "@/data/navItems.js";
import { useProfileStore } from '@/stores/profile'

const NAV_CATEGORY_LABELS = [
  'Principal', 'Communications', 'Mon Activité', 'Finance',
  'Équipes', 'Paramètres', 'Résultats', 'Templates', 'Dev'
]

export default {
  setup() {
    return {
      navItems,
      store: useProfileStore()
    }
  },
  data() {
    return {
      unsub: [],
      isDeploy: false,
    }
  },
  computed: {
    navContent() {
      let nav = []
      
      if(!this.store.profile) {
        return nav
      }

      navItems.forEach((cat, catIdx) => {
        let items = []

        cat.forEach(item => {
          let itemRoute = this.$router.resolve({ path: item.path })
          
          let visible = true
          if(!this.store.profile || this.store.profile.role == 'User') {
            visible = false
          }
          if(itemRoute.meta.accessRules.devNeeded && !this.store.profile.dev) {
            visible = false
          }
          if(itemRoute.meta.accessRules.accountNeeded && itemRoute.meta.accessRules.roleNeeded.includes('User')){
            visible = false
          }

          if(visible) {
            item.dev = itemRoute.meta.accessRules.devNeeded

            if(itemRoute.meta.accessRules.roleNeeded.includes('Admin')){
              item.superAdminOnly = false
            }else if(itemRoute.meta.accessRules.roleNeeded.includes('SuperAdmin')){
              item.superAdminOnly = true
            }

            item.name = itemRoute.name
            item.title = itemRoute.meta.title
            
            items.push(item)
          }
        })

        if (items.length > 0) {
          nav.push({ label: NAV_CATEGORY_LABELS[catIdx] || '', items })
        }
      })

      return nav
    }
  },
  methods: {
    updateRail(e) {
      this.isDeploy = !e;
    },
    getNavColorVar(colorName) {
      const themeColors = ['primary', 'secondary', 'accent', 'error', 'info', 'success', 'warning']
      if (themeColors.includes(colorName)) {
        return `var(--v-theme-${colorName})`
      }
      const palette = {
        'yellow': '255, 235, 59',
        'deep-orange': '255, 87, 34',
      }
      return palette[colorName] || 'var(--v-theme-primary)'
    },
  },
}

</script>